import React, {useState, useEffect} from "react";
import {Routes, Route, BrowserRouter as Router, Navigate} from "react-router-dom"
import Header from './components/Header'
import Discovery from './components/discovery';
import Details from './components/details';
import Main from './Main';
import Layer from "@arcgis/core/layers/Layer";
import DerivationService from "./services/DerivationService";
import esriConfig from "@arcgis/core/config";
import * as geometryJsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import {LicenseInfo} from '@mui/x-license';
import Login from './Login';
import UserService from "./services/UserService";
import FieldNames from './defaults/FieldNames.json';
import {useDispatch, useSelector} from "react-redux";
import {
    setConfig,
    setNifcToken,
    setRootServiceUrl,
    setViewRootServiceUrl,
    setSummaryViewRootServiceUrl
} from "./redux/slices/configurationSlice";
import "./App.css";
import AuthManager from "./components/esri/auth/AuthManager";
import {getLegacyModifiedAttributes, getWFFTSModifiedAttributes, isFeaturePostFire} from "./utils/FeatureHelper";
import UserAdminDialog from "./components/discovery/popover/UserAdminDialog";
import BudgetManagementDialog from "./components/discovery/popover/workflow/BudgetManagementDialog";
import CarryoverManagementDialog from "./components/discovery/popover/workflow/CarryoverManagementDialog";
import DownloadDialog from "./components/discovery/popover/workflow/DownloadDialog";
import {IFPRSGlobalProvider} from "./IFPRSGlobalContext";
import logo from '../src/images/inform_logo.png';
import {Dialog} from "@mui/material";
import {createTheme, ThemeProvider} from '@mui/material/styles';
import ErrorService from "./services/ErrorService";
import TargetManagementDialog from "./components/discovery/popover/workflow/TargetManagementDialog";
import {ResetFeatureFundingLinesByFeature} from "./utils/FundingHelper";
import {getSaveableDate} from "./utils/DateHelper";
import ReportingDialog from "./components/discovery/popover/workflow/reporting/ReportingDialog";
import BulkApprovalDialog from "./components/discovery/popover/workflow/BulkApprovalDialog";
import {validateCacheByProfile} from "./utils/AdminHelper";
import packageInfo from '../package.json';
import {setDataset} from "./redux/slices/filterSlice";
import AdminOverridesPanel from "./components/adminOverrides/AdminOverridesPanel";

window.authManager = new AuthManager();

const theme = createTheme({
    overrides: {
        MuiDialog: {
            root: {
                top: '94px !important'
            },
        },
    },
});


LicenseInfo.setLicenseKey('a25856da2deafb4941fff0c39c371685Tz0xMjI2NjEsRT0xNzk2MzQyMzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y');

export default function App() {
    const [dbLayerList] = useState([]);
    const [isTreatment, setIsTreatment] = useState(false);
    const [isCreatingPlannedFeature, setIsCreatingPlannedFeature] = useState(false);
    const [isCreatingActualFeature, setIsCreatingActualFeature] = useState(false);
    const [isCreatingPostFire, setIsCreatingPostFire] = useState(false);
    const [isCreatingPostFireProject, setIsCreatingPostFireProject] = useState(false);
    const [isEditingTreatment, setIsEditingTreatment] = useState(false);
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [isActuals, setIsActuals] = useState(false);
    const [isProject, setIsProject] = useState(false);
    const [project, setProject] = useState(null);
    const [listOpen, setListOpen] = useState(true);
    const [feature, setFeature] = useState(null);
    const [plannedFeature, setPlannedFeature] = useState(null);
    const [mode, setMode] = useState(FieldNames.modes.read);
    const [isNewFeature, setIsNewFeature] = useState(false);
    const [isApproved, setIsApproved] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [isWithinFiscalYear, setIsWithinFiscalYear] = useState(true);
    const [userCredential, setUserCredential] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const [userRoleInfo, setUserRoleInfo] = useState([]);
    const [isUserFound, setIsUserFound] = useState(false);
    const dispatch = useDispatch();
    const [isConfigLoaded, setIsConfigLoaded] = useState(false);
    const [configFile, setConfigFile] = useState(null);
    const [isInReadWriteGroup, setIsInReadWriteGroup] = useState(false);
    const [isCheckingCredentials, setIsCheckingCredentials] = useState(true);
    const [derivationError, setDerivationError] = useState("");
    const [derivationErrorOpen, setDerivationErrorOpen] = useState(false);
    const [headerheight, setHeaderHeight] = useState(125);
    const [mapSnackbarMessage, setMapSnackbarMessage] = useState("");
    const [mapSnackbarSeverity, setMapSnackbarSeverity] = useState("success");
    const [mapSnackbarOpen, setMapSnackbarOpen] = useState(false);
    const [tribeSource, setTribeSource] = useState([]);
    const [showMap, setShowMap] = useState(true);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const nifcToken = useSelector((state) => state.configuration.nifcToken);
    const config = useSelector((state) => state.configuration.config);
    const rootServiceUrl = useSelector((state) => state.configuration.rootServiceUrl);
    const basename = import.meta.env.BASE_URL;


    useEffect(() => {
        esriConfig.portalUrl = "https://nifc.maps.arcgis.com";  //TODO: Unhardcode this


        window.api.getAppConfig().then(response => {
            dispatch(setConfig(response));
            setIsConfigLoaded(true);
            setConfigFile(response);
            //DEV NOTE: Do NOT Put any Queries in here to external services -> It will interrupt the query to Auth and if it fails Auth thinks that the Login is failing
            //This will cause and infinite loop -> Crashes entire application
        });
    }, []);


    useEffect(() => {
        if (userInfo) {
            const isUserPostfire = userInfo[FieldNames.userFields.isPostFire] === FieldNames.yesNo.yes;
            const isUserFuels = userInfo[FieldNames.userFields.isFuels] === FieldNames.yesNo.yes;
            const tempDataset = ((isUserPostfire && isUserFuels) ? "FUELS" : ((isUserPostfire && !isUserFuels) ? "POSTFIRE" : "FUELS"));
            dispatch(setDataset(tempDataset))
        }
    }, [userInfo])

    useEffect(() => {
        if (!isConfigLoaded || !configFile) {
            return;
        }
        console.log('IFPRS Version ' + packageInfo.version + ' is starting up...');

        window.authManager = new AuthManager(
            configFile.appId[configFile.env],
            configFile.portalUrl,
            configFile.loginWithPopup
        );

        window.authManager.startup().then(() => {
            window.authManager.checkLogin().then(
                response => {
                    const user = response.user;
                    const token = response.token;
                    dispatch(setNifcToken(token));
                    setUserCredential(user);
                    const sharingUrl = "https://nifc.maps.arcgis.com/sharing/rest/content/items";
                    const proxyUrl = "https://utility.arcgis.com";

                    //Append our token to any NIFC request
                    // esriConfig.request.interceptors.push({
                    //     urls: sharingUrl,
                    //     before({url, requestOptions}) {
                    //         requestOptions.query.token = token;
                    //     },
                    //     after({data, url, requestOptions}) {
                    //         //console.log("after", data, url, requestOptions);
                    //     }
                    // });

                    //Append our token to any ESRI proxy request
                    // esriConfig.request.interceptors.push({
                    //   urls: proxyUrl,
                    //   before({ url, requestOptions }) {
                    //     requestOptions.query.token = token;
                    //   },
                    //   after({ data, url, requestOptions }) {
                    //     //console.log("after", data, url, requestOptions);
                    //   }
                    // });

                    //set the views url
                    Layer.fromPortalItem({
                        portalItem: {
                            id: configFile.targetTreatmentView[configFile.env].portalItem.id
                        }
                    }).then(layer => {
                        layer.load().then(() => {
                            dispatch(setViewRootServiceUrl(layer.portalItem.url));
                        })
                    }, error => {
                        console.log(error)
                    });

                    //set the summary views url
                    Layer.fromPortalItem({
                        portalItem: {
                            id: configFile.summaryAttributesView[configFile.env].portalItem.id
                        }
                    }).then(layer => {
                        layer.load().then(() => {
                            dispatch(setSummaryViewRootServiceUrl(layer.portalItem.url));
                        })
                    }, error => {
                        console.log(error)
                    });

                    // Creates a layer from a Portal layer item id
                    Layer.fromPortalItem({
                        portalItem: {
                            id: configFile.actionAttributes[configFile.env].portalItem.id
                        }
                    }).then(layer => {
                        layer.load().then(() => {
                                dispatch(setRootServiceUrl(layer.portalItem.url));
                                window.api.getUserGroups(user.username, token).then(response => {
                                    const inReadWriteGroup = response.groups.filter(group => {
                                        return group.id === configFile.accessGroupId[configFile.env]
                                    }).length === 1;
                                    setIsInReadWriteGroup(inReadWriteGroup)
                                    const currentlyNonProduction = configFile.env !== "prod";
                                    let inNoGroups = !inReadWriteGroup;
                                    if (currentlyNonProduction && inNoGroups) {
                                        const inProductionReadWriteGroup = response.groups.filter(group => {
                                            return group.id === configFile.accessGroupId["prod"]
                                        }).length === 1;
                                        if (inProductionReadWriteGroup) {
                                            setIsInReadWriteGroup(inProductionReadWriteGroup)
                                            inNoGroups = false;
                                        }
                                    }

                                    if (inNoGroups) {
                                        setUserInfo(null);
                                        setUserRoleInfo([]);
                                        setIsUserFound(false);
                                    } else {

                                        // GeneralService.queryForLayers(layer.portalItem.url, token).then(response => {
                                        //   setDbLayerList(response);
                                        //   // In 1.7, move the below user queries into this promise chain and pass response in get the layer list
                                        //   // prior to the state variable being set.
                                        // });

                                        UserService.getUserByNifcUsername(layer.portalItem.url, user.username, configFile).then(response => {
                                            if (response && response.length > 0) {
                                                setUserInfo(response[0]);
                                                validateCacheByProfile(response[0]);
                                                if (response[0]) {
                                                    setIsUserFound(true);
                                                    UserService.getUserRoles(layer.portalItem.url, response[0][FieldNames.userFields.id], configFile).then(userRoles => {
                                                        setIsCheckingCredentials(false);
                                                        if (userRoles && userRoles.length > 0) {
                                                            setUserRoleInfo(userRoles);
                                                        } else {
                                                            setUserRoleInfo([]);
                                                        }

                                                    }).catch(error => {
                                                        ErrorService.addErrorLogEntry("SYSTEM", error);
                                                    });
                                                } else {
                                                    setIsUserFound(false);
                                                }


                                                let user = response[0];
                                                user[FieldNames.userFields.lastLogin] = getSaveableDate(new Date());
                                                UserService.updateUser(layer.portalItem.url, token, user, configFile).then(updatedResp => {
                                                    if (updatedResp && updatedResp.updateResults && updatedResp.updateResults.length > 0) {

                                                    }
                                                }).catch(error => {
                                                    ErrorService.addErrorLogEntry("SYSTEM", error);
                                                });
                                            } else {
                                                setIsUserFound(false) //TODO: We need to throw something in the UI here...
                                            }
                                        })
                                            .catch(error => {
                                                ErrorService.addErrorLogEntry("SYSTEM", error);
                                            });
                                    }
                                });
                            },
                            error => {
                                setIsUserFound(false);
                                setIsError(true);
                                if (error) {
                                    setErrorMessage(error.message)
                                    ErrorService.addErrorLogEntry("SYSTEM", error);
                                }
                            });
                    }, error => {
                        setIsUserFound(false);
                        setIsError(true);
                        if (error) {
                            setErrorMessage(error.message)
                            ErrorService.addErrorLogEntry("SYSTEM", error);
                        }
                    });
                },
                error => {
                    setIsUserFound(false);
                    if (error && error !== "User is not logged in") {
                        setIsError(true);
                        if (error) {
                            setErrorMessage(error.message)
                            ErrorService.addErrorLogEntry("SYSTEM", error);
                        }
                    }
                }
            )
        }, error => {
            setIsUserFound(false);
            setIsError(true);
            if (error) {
                setErrorMessage(error.message)
                ErrorService.addErrorLogEntry("SYSTEM", error);
            }
        });
    }, [isConfigLoaded, configFile]);

    const logout = () => {
        setUserCredential(null);
        setUserInfo(null);
        window.authManager.logout();

    }

    const rederiveFeatureInfo = async (feature, isTreatment, isFeatureActuals, isPoint, wfftsAttributes, legacyAttributes, setShowGlobalLoader, resetAcreage = true) => {
        setShowGlobalLoader(true)
        let plannedFields = FieldNames.featureFields;
        if (feature?.attributes[FieldNames.featureFields.isPoint] == FieldNames.yesNo.yes &&
            (feature?.attributes[FieldNames.featureFields.fundingUnitType] == FieldNames.unitTypes.national || feature?.attributes[FieldNames.featureFields.fundingUnitType] == FieldNames.unitTypes.regional) &&
            feature?.attributes[FieldNames.featureFields.category] == FieldNames.categoriesForChecking.programManagement) {
            return;
        }
        const isPostFire = isFeaturePostFire(feature?.attributes);
        if (isFeatureActuals || (!isFeatureActuals && wfftsAttributes)) {
            let actualFields = FieldNames.featureFields;
            if (!isTreatment) {
                actualFields = FieldNames.featureFields;
                plannedFields = FieldNames.featureFields;
            }

            const perimeter = geometryJsonUtils.fromJSON(feature.geometry);
            const isManual = (feature && feature.attributes && feature.attributes[plannedFields.isVegetationManual] === FieldNames.yesNo.yes) ? true : false;
            DerivationService.deriveAttributesForGeometry(perimeter, false, isTreatment, feature?.attributes[FieldNames.featureFields.joinFeature], isFeatureActuals, configFile, userRoleInfo, isManual, isPostFire, isPoint, setShowGlobalLoader).then(attributes => {
                let tempAttr;
                if (attributes && attributes.attributes) {
                    tempAttr = {...feature.attributes, ...attributes.attributes};

                } else {
                    tempAttr = {...feature.attributes};
                }
                const tempPeri = feature.geometry
                let tempFeatureAttr;
                if (wfftsAttributes) {
                    tempFeatureAttr = getWFFTSModifiedAttributes(tempAttr, isTreatment, isFeatureActuals, wfftsAttributes);
                } else if (legacyAttributes) {
                    tempFeatureAttr = getLegacyModifiedAttributes(tempAttr, legacyAttributes, actualFields);
                } else {
                    tempFeatureAttr = getLegacyModifiedAttributes(tempAttr, null, actualFields);
                }

                let attrObjectID = null;
                if (tempAttr) {
                    attrObjectID = tempAttr[FieldNames.featureFields.objectID]
                }
                if (attrObjectID && resetAcreage) {
                    ResetFeatureFundingLinesByFeature(tempFeatureAttr, userInfo).then(resp => {
                        tempFeatureAttr[FieldNames.featureFields.isFundingAcresManual] = FieldNames.yesNo.no;
                        let tempFeature = {
                            attributes: tempFeatureAttr,
                            geometry: tempPeri
                        }
                        setFeature(tempFeature);
                        setShowGlobalLoader(false);
                        return tempFeature;
                    });
                } else {
                    let tempFeature = {
                        attributes: tempFeatureAttr,
                        geometry: tempPeri
                    }
                    setFeature(tempFeature);
                    setShowGlobalLoader(false);
                    return tempFeature;
                }
            }).catch(error => {
                ErrorService.addErrorLogEntry(userRoleInfo[FieldNames.userFields.nifcUsername], error);
                setShowGlobalLoader(false);
            }).finally(() => {
            });

        } else {
            const perimeter = geometryJsonUtils.fromJSON(feature.geometry);
            const isManual = (feature && feature.attributes && feature.attributes[plannedFields.isVegetationManual] === FieldNames.yesNo.yes) ? true : false;
            DerivationService.deriveAttributesForGeometry(perimeter, false, isTreatment, feature?.attributes[FieldNames.featureFields.joinFeature], isFeatureActuals, configFile, userRoleInfo, isManual, isPostFire, isPoint, setShowGlobalLoader).then(attributes => {
                let tempFeature;
                let tempAttr;
                let tempPeri = feature.geometry;
                if (attributes?.attributes) {
                    tempAttr = {...feature.attributes, ...attributes.attributes};
                    if (attributes.error) {
                        setDerivationError(attributes.error);
                        setDerivationErrorOpen(true);
                    }
                } else {
                    tempAttr = {...feature.attributes};
                }

                let attrObjectID = null;
                if (tempAttr) {
                    attrObjectID = tempAttr[FieldNames.featureFields.objectID]
                }
                if (attrObjectID && resetAcreage) {
                    ResetFeatureFundingLinesByFeature(tempAttr, userInfo).then(resp => {
                        tempAttr[FieldNames.featureFields.isFundingAcresManual] = FieldNames.yesNo.no;
                        tempFeature = {
                            attributes: tempAttr,
                            geometry: tempPeri
                        }
                        setFeature(tempFeature);
                        setShowGlobalLoader(false);
                        return tempFeature;
                    });
                } else {
                    tempFeature = {
                        attributes: tempAttr,
                        geometry: tempPeri
                    }
                    setFeature(tempFeature);
                    setShowGlobalLoader(false);
                    return tempFeature;
                }
            }).catch(error => {
                ErrorService.addErrorLogEntry(userRoleInfo[FieldNames.userFields.nifcUsername], error);
                setShowGlobalLoader(false);
            }).finally(() => {
            });
        }
    }

    const splashStyle = {
        backgroundSize: 'cover, cover',
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    }

    return (
        (isError && errorMessage !== "User is not logged in") ? (
                <div className="login-container" style={splashStyle}>
                    <ThemeProvider theme={theme}>
                        <Dialog open={true}>
                            <div style={{margin: 20, color: 'rgba(73, 73, 73, 0.6)'}}>
                                <div style={{textAlign: 'center'}}>
                                    <img src={logo} width="177px" alt="InFORM Inspector"/>
                                    <p>Error: {errorMessage}</p>
                                    <p>Inform Fuels has encountered an error and cannot proceed.</p>
                                    <p>You may try reloading your browser.</p>
                                </div>
                            </div>
                        </Dialog>
                    </ThemeProvider>
                </div>
            ) :
            (userInfo && isUserFound && isInReadWriteGroup && userRoleInfo && userRoleInfo.length > 0) ?
                <div style={{height: '100vh'}}>
                    <div className="app-content"
                         style={{top: 0, height: '100vh', display: (showMap ? "flex" : "block")}}>
                        <Router basename={basename}>
                            <IFPRSGlobalProvider dbLayerList={dbLayerList}>
                                <Header
                                    isTreatment={isTreatment}
                                    isCreatingPlannedFeature={isCreatingPlannedFeature}
                                    setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
                                    isCreatingActualFeature={isCreatingActualFeature}
                                    setIsCreatingActualFeature={setIsCreatingActualFeature}
                                    isEditingTreatment={isEditingTreatment}
                                    setIsEditingTreatment={setIsEditingTreatment}
                                    feature={feature}
                                    setFeature={setFeature}
                                    mode={mode}
                                    rederiveFeatureInfo={rederiveFeatureInfo}
                                    isNewFeature={isNewFeature}
                                    isApproved={isApproved}
                                    isActuals={isActuals}
                                    setIsTreatment={setIsTreatment}
                                    plannedFeature={plannedFeature}
                                    userInfo={userInfo}
                                    setUserInfo={setUserInfo}
                                    userRoleInfo={userRoleInfo}
                                    setUserRoleInfo={setUserRoleInfo}
                                    logout={logout}
                                    isCompleted={isCompleted}
                                    isWithinFiscalYear={isWithinFiscalYear}
                                    derivationError={derivationError}
                                    setDerivationError={setDerivationError}
                                    derivationErrorOpen={derivationErrorOpen}
                                    setDerivationErrorOpen={setDerivationErrorOpen}
                                    headerHeight={headerheight}
                                    setHeaderHeight={setHeaderHeight}
                                    mapSnackbarMessage={mapSnackbarMessage}
                                    setMapSnackbarMessage={setMapSnackbarMessage}
                                    mapSnackbarOpen={mapSnackbarOpen}
                                    setMapSnackbarOpen={setMapSnackbarOpen}
                                    mapSnackbarSeverity={mapSnackbarSeverity}
                                    setMapSnackbarSeverity={setMapSnackbarSeverity}
                                    setShowMap={setShowMap}
                                    isCreatingPostFire={isCreatingPostFire}
                                    setIsCreatingPostFire={setIsCreatingPostFire}
                                    isCreatingPostFireProject={isCreatingPostFireProject}
                                    setIsCreatingPostFireProject={setIsCreatingPostFireProject}
                                    isProject={isProject}
                                />
                                <Routes>
                                    <Route path='/' element={<Navigate to='/home' replace/>}/>
                                    {['/treatments/', '/activities/', '/projects/'].map((path, i) =>
                                        <Route key={i} path={path} element={<Navigate to='/home' replace/>}/>
                                    )}
                                    <Route path="/home" element={
                                        <Discovery
                                            setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
                                            setIsCreatingActualFeature={setIsCreatingActualFeature}
                                            setIsTreatment={setIsTreatment}
                                            isTreatment={isTreatment}
                                            listOpen={listOpen}
                                            setListOpen={setListOpen}
                                            setIsEditingTreatment={setIsEditingTreatment}
                                            selectedFeatures={selectedFeatures}
                                            setSelectedFeatures={setSelectedFeatures}
                                            setMode={setMode}
                                            setPlannedFeature={setPlannedFeature}
                                            isCreatingActualFeature={isCreatingActualFeature}
                                            isCreatingPlannedFeature={isCreatingPlannedFeature}
                                            userInfo={userInfo}
                                            userRoleInfo={userRoleInfo}
                                            headerheight={headerheight}
                                        />
                                    }/>
                                    <Route path='/projects/new' element={<Navigate to='/f/projects/new' replace/>}/>
                                    {['/f/projects/new', '/pf/projects/new'].map((path, i) =>
                                        <Route key={i} path={path} element={
                                            <Details
                                                isTreatment={true}
                                                feature={feature}
                                                setFeature={setFeature}
                                                mode={mode}
                                                setMode={setMode}
                                                setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
                                                setIsCreatingActualFeature={setIsCreatingActualFeature}
                                                isNewFeature={isNewFeature}
                                                setIsNewFeature={setIsNewFeature}
                                                setIsApproved={setIsApproved}
                                                isApproved={isApproved}
                                                setIsActuals={setIsActuals}
                                                selectedFeatures={selectedFeatures}
                                                setSelectedFeatures={setSelectedFeatures}
                                                isActuals={isActuals}
                                                setIsTreatment={setIsTreatment}
                                                setPlannedFeature={setPlannedFeature}
                                                plannedFeature={plannedFeature}
                                                userInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setIsCompleted={setIsCompleted}
                                                setIsWithinFiscalYear={setIsWithinFiscalYear}
                                                isWithinFiscalYear={isWithinFiscalYear}
                                                setDerivationError={setDerivationError}
                                                setDerivationErrorOpen={setDerivationErrorOpen}
                                                headerheight={headerheight}
                                                rederiveFeatureInfo={rederiveFeatureInfo}
                                                isProject={isProject}
                                                setIsProject={setIsProject}
                                                project={project}
                                                setProject={setProject}
                                                setIsCreatingPostFireProject={setIsCreatingPostFireProject}
                                            />
                                        }/>
                                    )}
                                    <Route path='/projects/:featureId'
                                           element={<Navigate to='/f/projects/:featureId' replace/>}/>
                                    {['/f/projects/:featureId', '/pf/projects/:featureId'].map((path, i) =>
                                        <Route key={i} path={path} element={
                                            <Details
                                                isTreatment={true}
                                                feature={feature}
                                                setFeature={setFeature}
                                                mode={mode}
                                                setMode={setMode}
                                                setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
                                                setIsCreatingActualFeature={setIsCreatingActualFeature}
                                                isNewFeature={isNewFeature}
                                                setIsNewFeature={setIsNewFeature}
                                                setIsApproved={setIsApproved}
                                                isApproved={isApproved}
                                                setIsActuals={setIsActuals}
                                                selectedFeatures={selectedFeatures}
                                                setSelectedFeatures={setSelectedFeatures}
                                                isActuals={isActuals}
                                                setIsTreatment={setIsTreatment}
                                                setPlannedFeature={setPlannedFeature}
                                                plannedFeature={plannedFeature}
                                                userInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setIsCompleted={setIsCompleted}
                                                setIsWithinFiscalYear={setIsWithinFiscalYear}
                                                isWithinFiscalYear={isWithinFiscalYear}
                                                setDerivationError={setDerivationError}
                                                setDerivationErrorOpen={setDerivationErrorOpen}
                                                headerheight={headerheight}
                                                rederiveFeatureInfo={rederiveFeatureInfo}
                                                isProject={isProject}
                                                setIsProject={setIsProject}
                                                project={project}
                                                setProject={setProject}
                                                setShowMap={setShowMap}
                                                isCreatingPostFire={isCreatingPostFire}
                                                setIsCreatingPostFire={setIsCreatingPostFire}
                                                setIsCreatingPostFireProject={setIsCreatingPostFireProject}
                                            />
                                        }/>
                                    )}
                                    <Route path='/treatments/:featureId'
                                           element={<Navigate to='/f/treatments/:featureId' replace/>}/>
                                    <Route path='/treatments/estimated/:featureId'
                                           element={<Navigate to='/f/estimated/:featureId' replace/>}/>
                                    <Route path='/f/treatments/estimated/:featureId'
                                           element={<Navigate to='/f/estimated/:featureId' replace/>}/>
                                    <Route path='/pf/treatments/estimated/:featureId'
                                           element={<Navigate to='/pf/estimated/:featureId' replace/>}/>
                                    <Route path='/treatments/actuals/:featureId'
                                           element={<Navigate to='/f/treatments/:featureId' replace/>}/>
                                    <Route path='/f/treatments/actuals/:featureId'
                                           element={<Navigate to='/f/treatments/:featureId' replace/>}/>
                                    <Route path='/pf/treatments/actuals/:featureId'
                                           element={<Navigate to='/pf/treatments/:featureId' replace/>}/>
                                    {['/f/treatments/:featureId', '/pf/treatments/:featureId'].map((path, i) =>
                                        <Route key={i} path={path} element={
                                            <Details
                                                isTreatment={true}
                                                feature={feature}
                                                setFeature={setFeature}
                                                mode={mode}
                                                setMode={setMode}
                                                setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
                                                setIsCreatingActualFeature={setIsCreatingActualFeature}
                                                isNewFeature={isNewFeature}
                                                setIsNewFeature={setIsNewFeature}
                                                setIsApproved={setIsApproved}
                                                isApproved={isApproved}
                                                setIsActuals={setIsActuals}
                                                selectedFeatures={selectedFeatures}
                                                setSelectedFeatures={setSelectedFeatures}
                                                isActuals={isActuals}
                                                setIsTreatment={setIsTreatment}
                                                setPlannedFeature={setPlannedFeature}
                                                plannedFeature={plannedFeature}
                                                userInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setIsCompleted={setIsCompleted}
                                                setIsWithinFiscalYear={setIsWithinFiscalYear}
                                                isWithinFiscalYear={isWithinFiscalYear}
                                                setDerivationError={setDerivationError}
                                                setDerivationErrorOpen={setDerivationErrorOpen}
                                                headerheight={headerheight}
                                                rederiveFeatureInfo={rederiveFeatureInfo}
                                                isProject={isProject}
                                                setIsProject={setIsProject}
                                                project={project}
                                                setProject={setProject}
                                                setIsCreatingPostFireProject={setIsCreatingPostFireProject}
                                            />
                                        }/>
                                    )}
                                    <Route path='/treatments/new' element={<Navigate to='/f/treatments/new' replace/>}/>
                                    {['/f/treatments/new/', '/pf/treatments/new'].map((path, i) =>
                                        <Route key={i} path={path} element={
                                            <Details
                                                isTreatment={true}
                                                feature={feature}
                                                setFeature={setFeature}
                                                mode={mode}
                                                setMode={setMode}
                                                setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
                                                setIsCreatingActualFeature={setIsCreatingActualFeature}
                                                isNewFeature={isNewFeature}
                                                setIsNewFeature={setIsNewFeature}
                                                setIsApproved={setIsApproved}
                                                isApproved={isApproved}
                                                setIsActuals={setIsActuals}
                                                selectedFeatures={selectedFeatures}
                                                setSelectedFeatures={setSelectedFeatures}
                                                isActuals={isActuals}
                                                setIsTreatment={setIsTreatment}
                                                setPlannedFeature={setPlannedFeature}
                                                plannedFeature={plannedFeature}
                                                userInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setIsCompleted={setIsCompleted}
                                                setIsWithinFiscalYear={setIsWithinFiscalYear}
                                                isWithinFiscalYear={isWithinFiscalYear}
                                                setDerivationError={setDerivationError}
                                                setDerivationErrorOpen={setDerivationErrorOpen}
                                                headerheight={headerheight}
                                                rederiveFeatureInfo={rederiveFeatureInfo}
                                                isProject={isProject}
                                                setIsProject={setIsProject}
                                                project={project}
                                                setProject={setProject}
                                                setIsCreatingPostFireProject={setIsCreatingPostFireProject}
                                            />
                                        }/>
                                    )}
                                    <Route path='/activities/:featureId'
                                           element={<Navigate to='/f/activities/:featureId' replace/>}/>
                                    <Route path='/activities/estimated/:featureId'
                                           element={<Navigate to='/f/activities/:featureId' replace/>}/>
                                    <Route path='/f/activities/estimated/:featureId'
                                           element={<Navigate to='/f/activities/:featureId' replace/>}/>
                                    <Route path='/pf/activities/estimated/:featureId'
                                           element={<Navigate to='/pf/activities/:featureId' replace/>}/>
                                    <Route path='/activities/actuals/:featureId'
                                           element={<Navigate to='/f/activities/:featureId' replace/>}/>
                                    <Route path='/f/activities/actuals/:featureId'
                                           element={<Navigate to='/f/activities/:featureId' replace/>}/>
                                    <Route path='/pf/activities/actuals/:featureId'
                                           element={<Navigate to='/pf/activities/:featureId' replace/>}/>
                                    {['/f/activities/:featureId', '/pf/activities/:featureId'].map((path, i) =>
                                        <Route key={i} path={path} element={
                                            <Details
                                                isTreatment={false}
                                                feature={feature}
                                                setFeature={setFeature}
                                                mode={mode}
                                                setMode={setMode}
                                                setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
                                                setIsCreatingActualFeature={setIsCreatingActualFeature}
                                                isNewFeature={isNewFeature}
                                                setIsNewFeature={setIsNewFeature}
                                                setIsApproved={setIsApproved}
                                                isApproved={isApproved}
                                                setIsActuals={setIsActuals}
                                                selectedFeatures={selectedFeatures}
                                                setSelectedFeatures={setSelectedFeatures}
                                                isActuals={isActuals}
                                                setIsTreatment={setIsTreatment}
                                                setPlannedFeature={setPlannedFeature}
                                                plannedFeature={plannedFeature}
                                                userInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setIsCompleted={setIsCompleted}
                                                setIsWithinFiscalYear={setIsWithinFiscalYear}
                                                isWithinFiscalYear={isWithinFiscalYear}
                                                setDerivationError={setDerivationError}
                                                setDerivationErrorOpen={setDerivationErrorOpen}
                                                headerheight={headerheight}
                                                rederiveFeatureInfo={rederiveFeatureInfo}
                                                isProject={isProject}
                                                setIsProject={setIsProject}
                                                project={project}
                                                setProject={setProject}
                                                setIsCreatingPostFireProject={setIsCreatingPostFireProject}
                                            />
                                        }/>
                                    )}
                                    <Route path='/activities/new' element={<Navigate to='/f/activities/new' replace/>}/>
                                    {['/f/activities/new/', '/pf/activities/new'].map((path, i) =>
                                        <Route key={i} path={path} element={
                                            <Details
                                                isTreatment={false}
                                                feature={feature}
                                                setFeature={setFeature}
                                                mode={mode}
                                                setMode={setMode}
                                                setIsCreatingPlannedFeature={setIsCreatingPlannedFeature}
                                                setIsCreatingActualFeature={setIsCreatingActualFeature}
                                                isNewFeature={isNewFeature}
                                                setIsNewFeature={setIsNewFeature}
                                                setIsApproved={setIsApproved}
                                                isApproved={isApproved}
                                                setIsActuals={setIsActuals}
                                                selectedFeatures={selectedFeatures}
                                                setSelectedFeatures={setSelectedFeatures}
                                                isActuals={isActuals}
                                                setIsTreatment={setIsTreatment}
                                                setPlannedFeature={setPlannedFeature}
                                                plannedFeature={plannedFeature}
                                                userInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setIsCompleted={setIsCompleted}
                                                setIsWithinFiscalYear={setIsWithinFiscalYear}
                                                isWithinFiscalYear={isWithinFiscalYear}
                                                setDerivationError={setDerivationError}
                                                setDerivationErrorOpen={setDerivationErrorOpen}
                                                headerheight={headerheight}
                                                rederiveFeatureInfo={rederiveFeatureInfo}
                                                isProject={isProject}
                                                setIsProject={setIsProject}
                                                project={project}
                                                setProject={setProject}
                                                setIsCreatingPostFireProject={setIsCreatingPostFireProject}
                                            />
                                        }/>
                                    )}
                                    <Route path="/admin">
                                        <Route index element={<Navigate replace to="/admin/users"/>}/>
                                        <Route path="/admin/users">
                                            <Route index element={<UserAdminDialog
                                                currentUserInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setShowMap={setShowMap}
                                                headerheight={headerheight}
                                            />}/>
                                        </Route>
                                        <Route path="/admin/overrides">
                                            <Route index element={<AdminOverridesPanel
                                                currentUserInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setShowMap={setShowMap}
                                                headerheight={headerheight}
                                            />}/>
                                        </Route>
                                    </Route>
                                    <Route path="/workflow">
                                        <Route index element={<Navigate replace to="/workflow/budget"/>}/>
                                        <Route path="/workflow/budget">
                                            <Route index element={<BudgetManagementDialog
                                                currentUserInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setShowMap={setShowMap}
                                                headerheight={headerheight}/>}/>
                                        </Route>
                                        <Route path="/workflow/carryover">
                                            <Route index element={<CarryoverManagementDialog
                                                currentUserInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setShowMap={setShowMap}
                                                headerheight={headerheight}
                                            />}/>
                                        </Route>
                                        <Route path="/workflow/downloads">
                                            <Route index element={<DownloadDialog
                                                currentUserInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setShowMap={setShowMap}
                                                headerheight={headerheight}
                                            />}/>
                                        </Route>
                                        <Route path="/workflow/targets">
                                            <Route index element={<TargetManagementDialog
                                                currentUserInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setShowMap={setShowMap}
                                                headerheight={headerheight}
                                            />}/>
                                        </Route>
                                        <Route path="/workflow/reporting">
                                            <Route index element={<ReportingDialog
                                                currentUserInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setShowMap={setShowMap}
                                                headerheight={headerheight}
                                            />}/>
                                        </Route>
                                        <Route path="/workflow/bulkapproval">
                                            <Route index element={<BulkApprovalDialog
                                                userInfo={userInfo}
                                                userRoleInfo={userRoleInfo}
                                                setShowMap={setShowMap}
                                                headerHeight={headerheight}
                                            />}/>
                                        </Route>
                                    </Route>
                                </Routes>
                                <Main
                                    showMap={showMap}
                                    listOpen={listOpen}
                                    isConfigLoaded={isConfigLoaded}
                                    userInfo={userInfo}
                                    userRoleInfo={userRoleInfo}
                                    mapSnackbarMessage={mapSnackbarMessage}
                                    setMapSnackbarMessage={setMapSnackbarMessage}
                                    mapSnackbarOpen={mapSnackbarOpen}
                                    setMapSnackbarOpen={setMapSnackbarOpen}
                                    mapSnackbarSeverity={mapSnackbarSeverity}
                                    setMapSnackbarSeverity={setMapSnackbarSeverity}
                                    headerheight={headerheight}
                                    setIsActuals={setIsActuals}
                                />
                            </IFPRSGlobalProvider>
                        </Router>
                    </div>
                </div> : <Login userCredential={userCredential} isUserFound={isUserFound} logout={logout}
                                isInReadWriteGroup={isInReadWriteGroup} userRoleInfo={userRoleInfo}
                                isCheckingCredentials={isCheckingCredentials}/>
    );
}
